import { useState } from "react";
import { Outlet, useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Users, LogOut, Building2, Wrench, Menu, X } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const isSuper = user?.role === "superadmin";

  const link = (to, icon, label, active) => (
    <Link to={to} data-testid={`nav-${label}`} onClick={() => setOpen(false)}
      className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${active ? "bg-white/10 text-white" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}>
      {icon} {label}
    </Link>
  );

  const menu = (
    <>
      <nav className="space-y-1 mt-4 flex-1">
        {link("/admin", <LayoutDashboard className="h-5 w-5" />, "Přehled", loc.pathname === "/admin")}
        {isSuper && link("/admin/teams", <Users className="h-5 w-5" />, "Pracovní týmy", loc.pathname === "/admin/teams")}
        {isSuper && link("/admin/svj/new", <Building2 className="h-5 w-5" />, "Nové SVJ", loc.pathname === "/admin/svj/new")}
        {isSuper && link("/technik", <Wrench className="h-5 w-5" />, "Pohled technika", false)}
      </nav>
      <div className="border-t border-white/10 pt-3">
        <div className="px-2 py-2 text-slate-300 text-sm truncate">{user?.email}</div>
        <div className="px-2 pb-2 text-xs text-slate-400">{isSuper ? "Superadmin" : "Předseda SVJ"}</div>
        <Button variant="ghost" onClick={() => { logout(); nav("/prihlaseni"); }} data-testid="logout-btn"
          className="w-full justify-start text-slate-300 hover:text-white hover:bg-white/5">
          <LogOut className="h-4 w-4 mr-2" /> Odhlásit se
        </Button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-[#F8FAFC]">
      <header className="md:hidden sticky top-0 z-40 flex items-center justify-between px-4 h-14 text-white" style={{ background: "#0A2540" }}>
        <Link to="/admin" className="okenfix-brand text-xl font-extrabold" style={{ color: "#C5A059" }}>OKENFIX</Link>
        <Button variant="ghost" size="sm" className="text-white hover:bg-white/10" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-btn" aria-label="Menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>
      </header>
      {open && (
        <div className="md:hidden fixed inset-0 top-14 z-30 flex flex-col p-4" style={{ background: "#0A2540" }} data-testid="mobile-menu">
          {menu}
        </div>
      )}
      <aside className="hidden md:flex w-64 shrink-0 flex-col p-4" style={{ background: "#0A2540" }}>
        <div className="okenfix-brand text-2xl font-extrabold px-2 py-4" style={{ color: "#C5A059" }}>OKENFIX</div>
        {menu}
      </aside>
      <main className="flex-1 min-w-0 overflow-auto"><div className="max-w-6xl mx-auto p-4 sm:p-6 md:p-8"><Outlet /></div></main>
    </div>
  );
}
